(ns machtfit.stepchall.tracker
  (:require [machtfit.core :as machtfit]
            [machtfit.startpage.subs :as startpage.subs]
            [machtfit.stepchall.modal :as modal]
            [machtfit.stepchall.subs :as subs]
            [machtfit.storage :as-alias storage]
            [machtfit.translation :refer [t]]
            [machtfit.utils :as utils]
            [re-frame.core :as rf]))

(rf/reg-sub ::tracker-intro-dismissed?
  :<- [:get [:stepchall :id]]
  :<- [:get [:ui :stepchall :flag-tracker-intro-dismissed?]]

  (fn [[stepchall-id intros-dismissed] _]
    (utils/in? intros-dismissed stepchall-id)))

(rf/reg-sub ::show-tracker-intro?
  :<- [::tracker-intro-dismissed?]
  :<- [::startpage.subs/is-app?]
  :<- [::subs/is-team-member?]

  (fn [[tracker-intro-dismissed? is-app? is-team-member?] _]
    (and (not tracker-intro-dismissed?)
         is-app?
         is-team-member?)))

(defn restore-from-local-storage [db local-storage]
  (let [key 'machtfit.app.stepchall.tracker-intro-dismissed?
        value (get local-storage key #{})]
    (assoc-in db [:ui :stepchall :flag-tracker-intro-dismissed?] value)))

(rf/reg-event-fx ::tracker-intro-close-clicked
  (fn [{:keys [db]} _]
    (let [stepchall-id (-> db :stepchall :id)
          intros-dismissed (-> db :ui :stepchall :flag-tracker-intro-dismissed?
                               ((fnil conj #{}) stepchall-id))]
      {:db (assoc-in db [:ui :stepchall :flag-tracker-intro-dismissed?] intros-dismissed)
       ::storage/local-storage-put {'machtfit.app.stepchall.tracker-intro-dismissed? intros-dismissed}})))

(defn tracker-intro []
  (let [show-tracker-intro? @(rf/subscribe [::show-tracker-intro?])
        steps-as-main-unit? @(rf/subscribe [::subs/steps-as-main-unit?])]
    (when (and show-tracker-intro? steps-as-main-unit?)
      (let [on-close-click #(rf/dispatch [::tracker-intro-close-clicked])]
        [modal/modal {:img-src (machtfit/static "img/stepchall/tracker-machtfit.svg")
                      :title (t {:de "Mehr Zeit zum Entspannen."
                                 :en "Make more time to relax."})
                      :content [:p (t {:de (str "Wusstest du, dass du deine Schritte mit einem Fitnesstracker "
                                                "von Garmin oder Polar automatisiert erfassen kannst? "
                                                "Gehe einfach in deine Profileinstellungen und verbinde deinen "
                                                "Fitnesstracker mit der App.")
                                       :en (str "Now you can automatically count your steps with your "
                                                "Garmin or Polar device. Just activate the automatic step "
                                                "counting in your profile.")})]
                      :button-group [{:text (t {:de "Weiter"
                                                :en "Continue"})
                                      :on-click on-close-click
                                      :style "white"}]
                      :close-button {:on-click on-close-click}
                      :modal-style "full-screen branded-bg left-aligned"}]))))
